export const EMAIL_OTP_LENGTH = 6;
export const NON_DIGIT_PATTERN = /\D/g;
export const PHONE_CODE_PATTERN = /^\d{4,10}$/;
export const PHONE_CODE_MAX_LENGTH = 10;
export const CONTACT_RESEND_SECONDS = 60;
export const CONTACT_TIMER_INTERVAL_MS = 1000;
export const CONTACT_VERIFICATION_TITLE = "Give employers a way to reach you";
export const CONTACT_EDIT_BUTTON_CLASS_NAME =
  "ml-1.5 inline-flex size-6 shrink-0 items-center justify-center rounded text-[#0D41E1] align-middle transition-colors hover:bg-black/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D41E1] disabled:pointer-events-none disabled:opacity-40";
export const CONTACT_EDIT_ICON_CLASS_NAME = "size-3.5";
